import { render, staticRenderFns } from "./code-component.vue?vue&type=template&id=c80d16da&scoped=true"
import script from "./code-component.vue?vue&type=script&lang=ts"
export * from "./code-component.vue?vue&type=script&lang=ts"
import style0 from "./code-component.vue?vue&type=style&index=0&id=c80d16da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80d16da",
  null
  
)

export default component.exports